import Document from '@tiptap/extension-document';

export const HIDDEN_TASK_LIST_TITLE_ATTR = 'hiddenTaskListTitle';

export const TaskListDocument = Document.extend({
    // An optional, single, unstyled title line followed by the task list.
    content: 'taskListTitle? taskList',

    addAttributes() {
        return {
            // Supports toggling the task list title on and off
            // When a title is hidden, its text is stored in this attribute
            // When toggled on, the hidden title is restored as a TaskListTitle content node
            [HIDDEN_TASK_LIST_TITLE_ATTR]: {
                default: null,
                rendered: false,
            },
        };
    },
});
